import { SPSelection } from "../SPSelection";
import { SPOpenBet } from "../SPOpenBet";

/**
 *  defines SPPurchase.
 *
 * @typedef
 * @type {Object}
 * @property {purchaseId} Unique identifier
 * @property {name} Name of the event
 * @property {customerId} ID of the customer
 * @property {purchaseDate} Date when the purchase was placed
 * @property {currencyCode} Code of the currecny($,)
 * @property {currentBalance} currentBalance of the customer
 * @property {oddsStyleId} ID of the Odds Style
 * @property {purchaseStatus} Status of the purchase Won/Lost
 * @property {totalGain} Gain of the purchase
 * @property {totalStake} All the stakes for the purchase
 * @property {selections} All selections for the purchase
 * @property {bets} All bets for the purchase
 */

export class SPPurchase {
    purchaseId: string;
    purchaseDate: Date;
    customerId: number;
    currencyCode: string;
    currentBalance: string;
    oddsStyleId: number;
    purchaseStatus: number;
    totalGain: number;
    totalStake: number;
    selections: SPSelection[];
    bets: SPOpenBet[];

    constructor(source: SPPurchase) {
        this.purchaseId = source.purchaseId;
        this.purchaseDate = source.purchaseDate;
        this.customerId = source.customerId;
        this.currencyCode = source.currencyCode;
        this.currentBalance = source.currentBalance;
        this.oddsStyleId = source.oddsStyleId;
        this.purchaseStatus = source.purchaseStatus;
        this.totalGain = source.totalGain;
        this.totalStake = source.totalStake;
        this.bets = source.bets;
        this.selections = source.selections;
    }
}